(function () {
    'use strict';

    angular
        .module('app')
        .controller('DocumentTemplateEditorPdfTextboxPropertiesDialogCtrl', DocumentTemplateEditorPdfTextboxPropertiesDialogCtrl);

    DocumentTemplateEditorPdfTextboxPropertiesDialogCtrl.$inject = ['DialogInstance', 'FieldSelectorService', 'pdfedit_fontList', 'selectedPdfElements', 'entityTemplate'];

    /**
     * @ngdoc Controller
     * @description
     *
     * A dialog for specifying the properties of a textbox on a PDF document template.
     */
    function DocumentTemplateEditorPdfTextboxPropertiesDialogCtrl(DialogInstance, FieldSelectorService, pdfedit_fontList, selectedPdfElements, entityTemplate) {
        /* jshint validthis:true */
        var vm = this;
        vm.selectedPdfElements = selectedPdfElements;
        vm.fontList = pdfedit_fontList;
        vm.pickField = pickField;
        vm.ok = ok;

        function pickField() {
            var selectedFields = [];
            if (!_.isNil(vm.selectedPdfElements[0].placeHolder) && vm.selectedPdfElements[0].placeHolder.length) {
                selectedFields.push(vm.selectedPdfElements[0].placeHolder);
            }

            FieldSelectorService.displayDialogForEntityTemplate(
                entityTemplate, {
                    multiSelect: false,
                    fieldFormatter: FieldSelectorService.fieldFormatters.simple,
                    selectedFields: selectedFields,
                    firstLevelFieldsOnly: false,
                    includeOrganisation: true,
                    includeCurrentUser: true,
                    includeDocumentTemplate: true,
                    includeFileDetails: true,
                    includeEntitySystem: true
                }).then(selectFieldsOK);

            function selectFieldsOK(selectedFields) {
                vm.selectedPdfElements[0].placeHolder = selectedFields[0];
            }
        }

        function ok() {
            DialogInstance.ok();
        }
    }
})();
